export const initializeNotifications = (payload) => {
	return {
		type: 'initialize_notification',
		payload: payload,
	};
};
export const updateNotifications = (payload) => {
	return {
		type: 'update_notification',
		payload: payload,
	};
};
export const updateRecentNotifications = (payload) => {
	return {
		type: 'update_recent_notification',
		payload: payload,
	};
};
export const clearNotification = () => {
	return {
		type: 'clear_notification',
	};
};
